import {
  ArrowLeftIcon,
  Button,
  Flex,
  Typography,
  emailRegex,
} from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';
import { useEffect, useRef } from 'react';

export interface ForgotPasswordProps {
  error: string | null;

  /** Function called when back arrow is clicked */
  onBackClick(): void;

  /** Function called when cancel button is clicked */
  onDoneClick(): void;

  /** Function called when submit button is clicked */
  onSubmit(data: EmailFormData): void;
}

export type EmailFormData = {
  email: string;
};

export const ForgotPassword = ({
  error,
  onBackClick,
  onDoneClick,
  onSubmit,
}: ForgotPasswordProps) => {
  const headingRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <Form name="forgot-password" onSubmit={onSubmit}>
      <Flex width="100%" alignItems="left">
        <ArrowLeftIcon
          size="md"
          mb={24}
          altText="Go back to sign in"
          onClick={onBackClick}
          data-testid="left-arrow"
        />
      </Flex>
      <Flex width="100%" flexDirection="column" alignItems="center">
        <div ref={headingRef} tabIndex={-1} style={{ marginBottom: 8 }}>
          <Typography branded variant="header-bold" textAlign="center">
            Reset your password
          </Typography>
        </div>
        <Typography textAlign="center">
          Enter your email address below and we’ll send you an email with
          instructions for creating a new password.
        </Typography>
        <Form.TextField
          type="email"
          autocomplete="off"
          label="Email"
          name="email"
          required
          requiredLabel
          requiredMessage="Please enter your email address."
          errorMessage="Please enter a valid email address (e.g., name@example.com)."
          errorOnBlur
          disableMobileInputStyling
          pattern={emailRegex}
          my={24}
        />
        {error && (
          <Typography color="error" mt={-12} mb={12}>
            {typeof error === 'string'
              ? error
              : 'There was an error trying to initiate the reset.'}
          </Typography>
        )}

        <Form.SubmitButton full variant="primary" label="Submit" mb={16} />
        <Button full variant="secondary" label="Cancel" onClick={onDoneClick} />
      </Flex>
    </Form>
  );
};
